/**
 * Single source of truth for the current auth provider.
 * The value is set once per session and never changes, so we cache it
 * in memory to avoid repeated sessionStorage reads across the app.
 */
let _cachedProvider = null;

function getProvider() {
  if (_cachedProvider === null) {
    _cachedProvider = sessionStorage.getItem('auth_provider');
  }
  return _cachedProvider;
}

export function isAuth0Flow() {
  return getProvider() === 'auth0';
}

export function setAuth0Provider() {
  _cachedProvider = 'auth0';
  sessionStorage.setItem('auth_provider', 'auth0');
}

export function setRedseaProvider() {
  _cachedProvider = 'redsea';
  sessionStorage.setItem('auth_provider', 'redsea');
}
